module.exports = __webpack_public_path__ + "fonts/f87b82207a9916ec3ed38b6415272e76.svg";